import React__default from 'react';
import Styles from './PhoneInput.module.scss.js';
import AppInput from '../app-input/AppInput.js';
import AppCheckbox from '../app-checkbox/AppCheckbox.js';
import WhatsappIcon from '../../icons/WhatsappGreen.svg.js';
import { useTranslation } from 'react-i18next';

const PhoneInput = ({ ischecked, onchange, containerStyles, inputvalue, inputonChange, inputonBlur, error, isValid, labelStyles, setFocus }) => {
    const { t } = useTranslation(["transporters", "common"]);
    return (React__default.createElement("div", { className: Styles.phoneInputWrap, style: containerStyles },
        React__default.createElement("div", { className: Styles.inputbox, style: { /*  height: "97px", */ paddingTop: "7px" } },
            React__default.createElement(AppInput, { name: "number", type: "number", isActiveByDefault: true, isRequired: true, labelText: t("transporter_profile_section.contact_details_form.fields.phone_number_field.label"), valuePrefix: "+91 -", value: inputvalue, onChange: inputonChange, onBlur: inputonBlur, error: error, isValid: isValid, setFocus: setFocus, showValidationErrOnChange: false, containerStyles: {
                // height: "90px",
                // paddingBottom: "30px",
                // marginBottom: "10px"
                } }),
            React__default.createElement("div", { className: Styles.whatsAppCheckbox },
                React__default.createElement(AppCheckbox, { labelText: t("transporter_profile_section.contact_details_form.fields.get_updates_checkbox"), isChecked: ischecked, onChange: onchange, styles: {
                        fontWeight: "bolder",
                        width: "200px",
                        fontSize: "12px",
                        color: "#0D132D"
                    }, labelClass: Styles.label, checkboxStyle: { width: "15px", height: "15px" } }),
                React__default.createElement("span", { className: Styles.whatsApp },
                    React__default.createElement(WhatsappIcon, null),
                    t("common:whatsApp"))))));
};

export { PhoneInput as default };
//# sourceMappingURL=PhoneInput.js.map
